import api from './api';
import { ApiResponse } from '../types';

export interface EmployerContract {
  id: number;
  user_id: string;
  signature_data: string;
  signature_date: string;
  agrees_to_terms: boolean;
  signed_at: string;
  contract_version: string;
  contract_terms?: string;
}

export interface EmployerVacancy {
  id: string;
  employer_id: string;
  dossier_id?: string;
  target_professional_id?: string;
  titel: string;
  beschrijving: string;
  professional_type: string;
  gender_preference?: string;
  availability_needed?: string;
  availability_date?: string;
  hours_per_month_min?: number;
  hours_per_month_max?: number;
  required_languages?: string[];
  active_regions?: string[];
  work_preference?: string;
  years_experience_min?: number;
  hourly_rate_max?: number;
  industry_experience_preferred?: string[];
  status: 'draft' | 'published' | 'closed' | 'filled';
  /** Minimale vetting-tier (migratie 179); null = geen eis */
  min_compliance_tier?: 'GOUD' | 'ZILVER' | 'BRONS' | null;
  published_at?: string;
  view_count?: number;
  application_count?: number;
  created_at: string;
}

export interface SearchRequest {
  id: number;
  employer_id: string;
  professional_type: string;
  search_criteria: any;
  additional_notes?: string;
  status: 'pending' | 'in_progress' | 'fulfilled' | 'cancelled';
  published_on_community: boolean;
  created_at: string;
}

export interface EmployerConnection {
  id: number;
  employer_id: string;
  professional_id: string;
  status: 'pending' | 'active' | 'paused' | 'terminated';
  connection_type: 'project' | 'long_term';
  connected_at?: string;
  notes?: string;
}

export const employerAPI = {
  // Contract
  getContract: () => 
    api.get<ApiResponse<EmployerContract>>('/employer/contract'),
  
  signContract: (data: { 
    signature_data: string; 
    agrees_to_terms: boolean; 
    contract_terms: string;
  }) => 
    api.post<ApiResponse<EmployerContract>>('/employer/contract/sign', data),
  
  // Vacancies
  getVacancies: () => 
    api.get<ApiResponse<EmployerVacancy[]>>('/employer/vacancies'),
  
  deleteVacancy: (id: string) => 
    api.delete<ApiResponse<null>>(`/employer/vacancy/${id}`),
  
  publishVacancy: (id: string) => 
    api.patch<ApiResponse<EmployerVacancy>>(`/employer/vacancy/${id}/publish`),
  
  // Connections
  createConnection: (professionalId: string, connectionType: 'project' | 'long_term') => 
    api.post<ApiResponse<EmployerConnection>>('/employer/connection', {
      professional_id: professionalId,
      connection_type: connectionType
    }),
};

export default employerAPI;
